<template>
    <div class="setting-page-content-wrapper notification-settings">
        <div class="page-header">
            <div class="title">{{ $t("search.allNotificationSettings") }}</div>
            <div class="subtitle">{{ $t("notification.notificationSettingsDesc") }}</div>
        </div>
        <section>
            <BasicActions
                :settings="settings"
                @update="updateScopeNotificationSettings"
                :title="group.title"
                v-for="group of groups"
                :key="group.id"
                :allowed-scopes="group.allowedScopes"
            />
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import BasicActions from "./BasicActions.vue";
import { ACTIVITY_API } from "../../../../../api/activity";

export default Vue.extend({
    name: "NotificationSettings",
    components: { BasicActions },
    data() {
        return {
            loading: false,
            settings: [],
            groups: [
                {
                    id: "basic",
                    title: this.$t("notification.basicActions"),
                    allowedScopes: [
                        "chat-assign",
                        "ticket-assign",
                        // "task-assign",
                        "chat-close-own",
                        "contact-owner",
                    ],
                },
                {
                    id: "supsis-crm",
                    title: this.$t("notification.crmActions"),
                    allowedScopes: [
                        "tag-actions-to-visitor",
                        "create-ticket",
                        "note-actions-to-visitor",
                        "visitor-profile-updates",
                    ],
                },
                {
                    id: "company",
                    title: this.$t("notification.companyActions"),
                    allowedScopes: [
                        "chat-start",
                        "department-crud",
                        "settings-crud",
                        "integration-channel-crud",
                        "login-form-crud",
                        "banned-word-crud",
                        "email-account-crud",
                        "prepared-content-crud",
                        "role-crud",
                        "tag-crud",
                        "welcome-message-crud",
                        "webhook-crud",
                        "billing-events",
                        // "task-workflow-crud",
                        // "task-crud",
                        "system-status",
                        "reservation-events",
                        "white-list-events",
                    ],
                },
                {
                    id: "task",
                    title: this.$t("message.taskModule"),
                    allowedScopes: [
                        "task-crud",
                        "task-created",
                        "task-deleted",
                        "task-workflow-created",
                        "task-workflow-updated",
                        "task-workflow-permanently-deleted",
                        "task-workflow-pipeline-stage-added",
                        "task-workflow-pipeline-stage-updated",
                        "task-workflow-pipeline-stage-deleted",
                        "task-module-rules-enabled",
                        "task-module-rules-disabled",
                        "task-module-rules-rule-added",
                        "task-module-rules-rule-deleted",
                        "task-module-rules-rule-updated",
                        "task-module-rules-rule-enabled",
                        "task-module-rules-rule-disabled",
                        "task-workflow-crud",
                        "task-assign",
                        "task-complet",
                        "task-archive",
                    ],
                },
                {
                    id: "automation",
                    title: this.$t("notification.automationActions"),
                    allowedScopes: [
                        "automation-created",
                        "automation-deleted",
                        "automation-published",
                        "automation-unpublished",
                        "automation-updated",
                    ],
                },
                {
                    id: "forms",
                    title: "Form İşlemleri",
                    allowedScopes: [
                        "form-created-scope",
                        "form-updated-scope",
                        "form-deleted",
                        "form-downloaded-scope",
                    ],
                },
                {
                    id: "users",
                    title: "Kullanıcı Bilgileri",
                    allowedScopes: [
                        "user-crud",
                        "user-info-changed-scope",
                    ],
                },
                {
                    id: "roles",
                    title: "Roller",
                    allowedScopes: [
                        "role-updated",
                    ],
                },
                {
                    id: "drive",
                    title: "Drive",
                    allowedScopes: [
                        "drive-folder-created",
                        "drive-folder-deleted",
                        "drive-folder-renamed",
                        "drive-file-added",
                        "drive-file-deleted",
                    ],
                },
                {
                    id: "contact-module",
                    title: "Kişi Modülü",
                    allowedScopes: [
                        "contact-module-rules-enabled",
                        "contact-module-rules-disabled",
                        "contact-module-rules-rule-added",
                        "contact-module-rules-rule-updated",
                        "contact-module-rules-rule-deleted",
                        "contact-module-rules-rule-enabled",
                        "contact-module-rules-rule-disabled",
                    ],
                },
                {
                    id: "developer",
                    title: "Geliştirici",
                    allowedScopes: [
                        "developer-token-changed",
                    ],
                },
                {
                    id: "contacts",
                    title: "Kişiler",
                    allowedScopes: [
                        "contact-batch-updated",
                        "chat-data-downloaded",
                    ],
                },
                {
                    id: "table",
                    title: "Tablolar",
                    allowedScopes: [
                        "table-created",
                        "table-deleted",
                        "table-restored",
                        "table-permanently-deleted",
                        "table-field-added",
                        "table-field-updated",
                        "table-field-deleted",
                        "table-view-actions",
                        "table-page-actions",
                        "table-widget-actions",
                        "table-permission-changed",
                        "table-data-downloaded",
                        "table-data-imported",
                        "table-data-batch-updated",
                        "table-data-batch-deleted",
                        "module-created",
                        "module-updated",
                        "module-deleted",
                        "relation-created",
                        "relation-updated",
                    ],
                },
                {
                    id: "web-app",
                    title: "Web Uygulamaları",
                    allowedScopes: [
                        "web-app-created",
                        "web-app-updated",
                        "web-app-deleted",
                        "web-tab-created",
                        "web-tab-updated",
                        "web-tab-deleted",
                    ],
                },
                {
                    id: "chatbot",
                    title: this.$t("notification.chatbotActions"),
                    allowedScopes: [
                        "chatbot-story-crud",
                        "chatbot-forward-chat",
                        "chatbot-user-segment-crud",
                        "chatbot-credit-low",
                    ],
                },
                {
                    id: "whatsapp",
                    title: this.$t("notification.whatsappActions"),
                    allowedScopes: [
                        "whatsapp-credit-low",
                        "whatsapp-customer-group-crud",
                        "whatsapp-broadcast-message-crud",
                        "whatsapp-template-message-crud",
                        "whatsapp-qr-code-status",
                    ],
                },
                {
                    id: "wallet",
                    title: "Cüzdan Otomatik Yükleme",
                    allowedScopes: [
                        "auto-rebalance-events",
                    ],
                },
                {
                    id: "voice-agent",
                    title: "Ses Agentleri",
                    allowedScopes: [
                        "voice-agent-created",
                        "voice-agent-updated",
                        "voice-agent-deleted",
                        "voice-agent-phone-number-inbound-agent-changed",
                        "voice-agent-phone-number-outbound-agent-changed",
                        "voice-agent-batch-call-created",
                        "voice-agent-knowledge-base-created",
                        "voice-agent-knowledge-base-deleted",
                    ],
                },
                {
                    id: "waba-supsis",
                    title: "Whatsapp Business API V2 Bildirimleri",
                    allowedScopes: ["waba-supsis-partner-remove", "waba-supsis-partner-added", "waba-supsis-account-deleted", "waba-supsis-account-violation", "waba-supsis-ad-account-linked", "waba-supsis-auth-intl-price-eligibility-update", "waba-supsis-disabled-update", "waba-supsis-mm-lite-terms-signed", "waba-supsis-partner-app-installed", "waba-supsis-partner-app-uninstalled", "waba-supsis-partner-client-certification-status-update", "waba-supsis-business-primary-location-country-update", "waba-supsis-volume-based-pricing-tier-update", "waba-supsis-message-template-components-update", "waba-supsis-message-template-status-update", "waba-supsis-template-category-update"],
                },
            ],
        };
    },
    mounted() {
        this.fetchSettings();
    },
    methods: {
        updateScopeNotificationSettings(item, platform, value) {
            this.settings = this.settings.map((setting) => {
                if (setting.scope === item) {
                    setting[platform] = value;
                }
                return setting;
            });
        },
        fetchSettings() {
            this.loading = true;
            ACTIVITY_API.NOTIFICATION.getMySettings()
                .then((res) => {
                    this.settings = res.data;
                    // Eksik scope'ları ekle
                    const requiredScopes = [
                        "web-app-created", "web-app-updated", "web-app-deleted",
                        "web-tab-created", "web-tab-updated", "web-tab-deleted",
                        "module-created", "module-updated", "module-deleted",
                        "relation-created", "relation-updated",
                        "table-data-downloaded", "table-data-imported", "table-data-batch-updated", "table-data-batch-deleted",
                        "contact-batch-updated", "chat-data-downloaded",
                        "waba-supsis-partner-remove", "waba-supsis-partner-added", "waba-supsis-account-deleted", 
                        "waba-supsis-account-violation", "waba-supsis-ad-account-linked",
                        "waba-supsis-auth-intl-price-eligibility-update", "waba-supsis-disabled-update",
                        "waba-supsis-mm-lite-terms-signed", "waba-supsis-partner-app-installed", "waba-supsis-partner-app-uninstalled", "waba-supsis-partner-client-certification-status-update", "waba-supsis-business-primary-location-country-update", "waba-supsis-volume-based-pricing-tier-update", "waba-supsis-message-template-components-update", "waba-supsis-message-template-status-update", "waba-supsis-template-category-update"
                    ];
                    requiredScopes.forEach(scope => {
                        if (!this.settings.find(s => s.scope === scope)) {
                            this.settings.push({
                                scope: scope,
                                web: true,
                                mobile: false,
                                email: false
                            });
                        }
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
});
</script>

<style scoped lang="scss">
.notification-settings {
    padding: 10px;
    .page-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        border-bottom: 1px solid var(--color-border-default);
        padding-bottom: 10px;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-default);
        }
    }
}
</style>
